import { getSubtle } from '@streamr/utils';
function arrayBufferToString(buffer) {
    return String.fromCharCode.apply(null, [...new Uint8Array(buffer)]);
}
async function exportCryptoKey(key, { isPrivate = false } = {}) {
    const keyType = isPrivate ? 'pkcs8' : 'spki';
    const exported = await getSubtle().exportKey(keyType, key);
    const exportedAsString = arrayBufferToString(exported);
    const exportedAsBase64 = btoa(exportedAsString);
    const TYPE = isPrivate ? 'PRIVATE' : 'PUBLIC';
    return `-----BEGIN ${TYPE} KEY-----\n${exportedAsBase64}\n-----END ${TYPE} KEY-----\n`;
}
export async function createRSAKeyPair(keyLength) {
    const { publicKey, privateKey } = await getSubtle().generateKey({
        name: 'RSA-OAEP',
        modulusLength: keyLength,
        publicExponent: new Uint8Array([1, 0, 1]), // 65537
        hash: 'SHA-256',
    }, true, ['encrypt', 'decrypt']);
    const [exportedPrivate, exportedPublic] = await Promise.all([
        exportCryptoKey(privateKey, {
            isPrivate: true,
        }),
        exportCryptoKey(publicKey, {
            isPrivate: false,
        }),
    ]);
    return { privateKey: exportedPrivate, publicKey: exportedPublic };
}
